export const RESULTS_NOT_DISPLAYED_MESSAGE = 'More results not displayed. ';
export const NARROW_SEARCH_PROMPT = 'Narrow your search for more targeted results.';
export const RESULT_NOT_FOUND = 'Sorry, no results found.';
